// Import model
import { StartIndividualContactAddTaskRequest } from '../models/StartIndividualContactAddTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartIndividualContactAddTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class StartIndividualContactAddTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a StartIndividualContactAddTaskRequest instance
   */
  static deserialize(json: string): StartIndividualContactAddTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartIndividualContactAddTaskRequest instance
   */
  static fromObject(obj: any): StartIndividualContactAddTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartIndividualContactAddTaskRequest');
    }


    const instance: StartIndividualContactAddTaskRequest = {
      dueDate: obj['DueDate'] as string | undefined,
      priority: obj['Priority'] as string | undefined,
      name: obj['Name'] as string | undefined,
      content: obj['Content'] as string | undefined,
      assignedUserId: obj['AssignedUserId'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartIndividualContactAddTaskRequest instances
   */
  static deserializeArray(json: string): StartIndividualContactAddTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartIndividualContactAddTaskRequest instance to a JSON string
   */
  static serialize(instance: StartIndividualContactAddTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartIndividualContactAddTaskRequest instance to a plain object
   */
  static toObject(instance: StartIndividualContactAddTaskRequest): any {
    return {
      'DueDate': instance.dueDate,
      'Priority': instance.priority,
      'Name': instance.name,
      'Content': instance.content,
      'AssignedUserId': instance.assignedUserId,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartIndividualContactAddTaskRequest instances to a JSON string
   */
  static serializeArray(instances: StartIndividualContactAddTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
